module.exports = __webpack_public_path__ + "img/customer-a-058.8664f520.png";